/** @jsxImportSource @emotion/react */

import * as React from 'react'
import styled from '@emotion/styled'
import { css, jsx } from '@emotion/react'
import { Primary, mixins } from '@sphinx/components-styles'
import { ActionBar, LeftActions, RightActions } from '../actionBar/action-bar'

type ActionBarType = 'standard' | 'multiselect'

interface ActionBarProps {
  type?: ActionBarType
  title?: string
  children?: React.ReactNode
}

const multiselectStyles = css`
  color: ${Primary.neutral.white};
  background-color: ${Primary.orange[100]};
  box-shadow: none;

  & > div > button {
    color: ${Primary.neutral.white};

    path {
      fill: ${Primary.neutral.white};
    }

    & > span {
      ${mixins.menu}
    }

    &:active {
      color: ${Primary.navy[100]};
      path {
        fill: ${Primary.navy[100]};
      }
    }
  }

  & > span {
    color: ${Primary.neutral.white};
  }
`

const ActionBarTitle = styled.span<Pick<ActionBarProps, 'type'>>`
  ${mixins.subheader}
  margin-right: auto;
  color: ${(props) =>
    props.type === 'standard' ? Primary.navy[100] : Primary.neutral.white};

  :active {
    color: ${(props) =>
      props.type === 'standard' ? Primary.navy[100] : Primary.neutral.white};
  }
`

const actionBarStyles = ({ type }: Pick<ActionBarProps, 'type'>) => css`
  padding: 0 14px 0 16px;

  ${type === 'multiselect' && multiselectStyles}
`

export const TableActionBar: React.FC<ActionBarProps> = ({
  type = 'standard',
  title,
  children,
}) => {
  return (
    <ActionBar css={actionBarStyles({ type })}>
      {title && title.length && (
        <LeftActions>
          <ActionBarTitle type={type}>{title}</ActionBarTitle>
        </LeftActions>
      )}
      <RightActions>{children}</RightActions>
    </ActionBar>
  )
}

export const ActionSeparator = styled.div`
  width: 1px;
  height: 34px;
  background: #e3e7ea;
  margin: 0 5px;
`
